import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MaterialModule } from 'src/app/shared/material.module';
import { MenuSidebarComponent } from '../menu-sidebar/menu-sidebar.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterOutlet, MaterialModule, MenuSidebarComponent],
})
export class ShellComponent implements OnInit {
  loginDisplay = false;
  displayedColumns: string[] = ['claim', 'value'];
  dataSource: any =[];
  isMobile = false;
  mobileSidebarOpen = false;

  constructor(
    private readonly authService: MsalService,
  ) { }

  ngOnInit(): void {
    this.updateViewportState();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateViewportState();
  }

  toggleMobileSidebar(): void {
    this.mobileSidebarOpen = !this.mobileSidebarOpen;
  }

  closeMobileSidebar(): void {
    if (this.isMobile) {
      this.mobileSidebarOpen = false;
    }
  }

  private updateViewportState(): void {
    this.isMobile = window.innerWidth < 992;

    if (!this.isMobile) {
      this.mobileSidebarOpen = false;
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

}